import { ReactNode, useState } from 'react'
import { BillingPaymentsHeaderSlotContext } from './BillingPaymentsHeaderSlotContext'

// Provider component to wrap the application
export function BillingPaymentsHeaderSlotProvider({
    children,
}: {
    children: ReactNode
}) {
    const [slot, setSlot] = useState<ReactNode>(null)

    return (
        <BillingPaymentsHeaderSlotContext.Provider value={{ slot, setSlot }}>
            {children}
        </BillingPaymentsHeaderSlotContext.Provider>
    )
}
